import type { ReactNode } from 'react'
import { Card, Flex, Typography, theme } from 'antd'

interface StatCardProps {
  icon?: ReactNode
  label: string
  /** Katta, aniq raqam — abonent birinchi shuni ko'radi */
  value: ReactNode
  /** Qo'shimcha izoh — masalan "50 000 so'm" ostida "oyiga" */
  hint?: ReactNode
  /** Rangli urg'u — masalan balans tugaganda ogohlantirish */
  tone?: 'default' | 'warning' | 'danger' | 'success'
}

/**
 * Bosh sahifadagi katta ko'rsatkich kartasi (balans, holat, muddat).
 *
 * Vazifa hujjatining asosiy talabi: "Katta, o'qilishi oson raqamlar" —
 * abonent oyiga bir-ikki marta kirib, darhol javob izlaydi. Shuning uchun
 * qiymat har doim eng katta, eng qalin matn: qolgan hamma narsa shunga
 * xizmat qiladi.
 */
export function StatCard({ icon, label, value, hint, tone = 'default' }: StatCardProps) {
  const { token } = theme.useToken()

  const toneColor: Record<NonNullable<StatCardProps['tone']>, string> = {
    default: token.colorText,
    warning: token.colorWarning,
    danger: token.colorError,
    success: token.colorSuccess,
  }

  return (
    <Card variant="borderless" style={{ height: '100%' }}>
      <Flex vertical gap={4}>
        <Flex align="center" gap={8}>
          {icon ? (
            <span style={{ color: token.colorTextSecondary, fontSize: 16 }}>{icon}</span>
          ) : null}
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            {label}
          </Typography.Text>
        </Flex>
        <Typography.Title
          level={2}
          className="xsib-stat-value"
          style={{ margin: 0, color: toneColor[tone], fontSize: 28, lineHeight: 1.2 }}
        >
          {value}
        </Typography.Title>
        {hint ? (
          <Typography.Text type="secondary" style={{ fontSize: 13 }}>
            {hint}
          </Typography.Text>
        ) : null}
      </Flex>
    </Card>
  )
}
